// import react from "react";
import { FaCheckCircle, FaBan } from "react-icons/fa";
import { Card } from "react-bootstrap";
import { formatDateddMMMyyyy } from "../../widgets/DateTime";
import { NumericFormat } from "react-number-format";
import { Grid, Tab, Tabs, Typography } from "@mui/material";
import { useMemo, useState } from "react";

const TableInformation = ({
  registerEmission = [],
  title = "",
  colorSetting = "normal",
  typeCategory = "",
  typeReport = ""
}) => {
  const [selectedFilterValue, setSelectedFilterValue] = useState("0");

  const fondoTable = (item) => {
    //CATEGORIZACION DE TABLAS - BACKGROUND
    if (item.porcentaje >= 100 || item.diasRestantes <= 0) {
      return "table-danger";
    } else if (
      (item.porcentaje >= 80 && item.porcentaje < 100) ||
      (item.diasRestantes >= 1 && item.diasRestantes < 30)
    ) {
      return "table-warning";
    } else if (item.porcentaje < 80) {
      return "table-secondary";
    }
  };

  const colorsTable = {
    normal: {
      bgTitle: "bg-primary",
      colorTitle: "text-white",
    },

    warning: {
      bgTitle: "bg-warning",
      colorTitle: "",
    },

    danger: {
      bgTitle: "bg-danger",
      colorTitle: "text-white",
    },
  };

  const selectFilterFunc = (event, value) => {
    setSelectedFilterValue(value);
  };

  const filterTabCategory = (item) => {
    if (typeCategory === "vencimiento") {
      //filtra fechas vencidas
      if (selectedFilterValue === "1" && item.diasRestantes > 0) return <></>;

      //filtra exceso de folios
      if (selectedFilterValue === "2" && item.porcentaje < 100) return <></>;
    }

    if (typeCategory === "cercanos") {
      //filtra fechas cercanos
      if (selectedFilterValue === "1" && item.diasRestantes > 30) return <></>;

      //filtra cercanos de exceso de folios
      if (selectedFilterValue === "2" && item.porcentaje < 80) return <></>;
    }
  };

  const orderByInformation = useMemo(() => {
    if (selectedFilterValue == 0) {
      return [...registerEmission].sort((a, b) => b.porcentaje - a.porcentaje);
    }

    if (selectedFilterValue == 1) {
      return [...registerEmission].sort(
        (a, b) => a.diasRestantes - b.diasRestantes
      );
    }

    if (selectedFilterValue == 2) {
      return [...registerEmission].sort((a, b) => b.porcentaje - a.porcentaje);
    }
  }, [registerEmission, selectedFilterValue]);

  return (
    <div
      className="col-md-12 mt-4"
      style={{
        position: "relative",
        height: "25rem",
        overflow: "auto",
        display: "block",
        margin: "3rem 0",
      }}
    >
      <Card>
        <Card.Header
          className={`${colorsTable[colorSetting].bgTitle} ${colorsTable[colorSetting].colorTitle} text-center fw-bold`}
        >
          {`${title}: ${registerEmission.length}`}
        </Card.Header>

        <Card.Body>
          <Tabs
            value={selectedFilterValue}
            onChange={selectFilterFunc}
            aria-label="basic tab filter plan"
          >
            <Tab
              value="0"
              label="📋 Todos"
              style={{ fontWeight: selectedFilterValue === "0" ? "bold" : "" }}
            />
            <Tab
              value="1"
              label="⏳ Por Fecha"
              style={{ fontWeight: selectedFilterValue === "1" ? "bold" : "" }}
            />
            <Tab
              value="2"
              label="📄 Por Folios"
              style={{ fontWeight: selectedFilterValue === "2" ? "bold" : "" }}
            />
          </Tabs>

          <div className="table-responsive mt-3">
            <table className="table table-sm table-bordered  table-hover">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Empresa</th>
                  <th>Plan</th>
                  <th>Estado plan</th>
                  <th>Estado compañia</th>

                  {/* Dos condicionales para filtrar columna en general ó detalle */}
                  {selectedFilterValue === "0" ||
                  selectedFilterValue === "1" ? (
                    <>
                      <th>Inicio Plan</th>
                      <th>Fin Plan</th>
                      <th>Dias Restantes</th>
                    </>
                  ) : (
                    <></>
                  )}

                  {/* Dos condicionales para filtrar columna en general ó detalle */}
                  {selectedFilterValue === "0" ||
                  selectedFilterValue === "2" ? (
                    <>
                      <th>Folios Anuales</th>
                      <th>Folios Consumidos</th>
                      <th>Folios Restantes</th>
                      <th>Plan Consumido</th>
                      {typeReport === "Vencimiento" ? <th>Plan Sugerido</th> : null}
                    </>
                  ) : (
                    <></>
                  )}
                </tr>
              </thead>
              <tbody>
                {orderByInformation.map((item, index) => {
                  //Lógica re calculo por categorías
                  if (filterTabCategory(item)) return <></>;
                  return (
                    <tr key={item.companyId} className={fondoTable(item)}>
                      <td className="text-center" style={{ fontSize: 14 }}>{index + 1}</td>
                      <td style={{ fontSize: 14 }}>{item.empresa_Nit + " - " + item.empresa}</td>
                      <td style={{ fontSize: 14 }} className="text-center">{item.plan}</td>
                      <td style={{ fontSize: 14 }} className="text-center">
                        {item.plan_Estado ? (
                          <FaCheckCircle color="green" />
                        ) : (
                          <FaBan color="red" />
                        )}
                      </td>
                      <td style={{ fontSize: 14 }} className="text-center">
                        {item.activeCompany ? (
                          <FaCheckCircle color="green" />
                        ) : (
                          <FaBan color="red" />
                        )}
                      </td>

                      {selectedFilterValue === "0" ||
                      selectedFilterValue === "1" ? (
                        <>
                          <td style={{ fontSize: 14 }} className="text-center">
                            {formatDateddMMMyyyy(item.fechaInicio)}
                          </td>
                          <td style={{ fontSize: 14 }} className="text-center">
                            {formatDateddMMMyyyy(item.finContratado)}
                          </td>
                          <td style={{ fontSize: 14 }} className="text-center">
                            <NumericFormat
                              displayType="text"
                              thousandSeparator=","
                              value={item.diasRestantes}
                            />
                          </td>
                        </>
                      ) : (
                        <></>
                      )}

                      {selectedFilterValue === "0" ||
                      selectedFilterValue === "2" ? (
                        <>
                          <td style={{ fontSize: 14 }} className="text-center">
                            <NumericFormat
                              displayType="text"
                              thousandSeparator=","
                              value={item.folios_Ano}
                            />
                          </td>

                          <td style={{ fontSize: 14 }} className="text-center">
                            <NumericFormat
                              displayType="text"
                              thousandSeparator=","
                              value={item?.emitidas || item?.fV_Emitidas}
                            />
                          </td>

                          <td style={{ fontSize: 14 }} className="text-center">
                            <NumericFormat
                              displayType="text"
                              thousandSeparator=","
                              value={item.folios_Ano - item.emitidas}
                            />
                          </td>
                          <td style={{ fontSize: 14 }} className="text-center">
                            <Grid
                              container
                              gap={"0.2rem"}
                              justifyContent={"center"}
                            >
                              <NumericFormat
                                displayType="text"
                                thousandSeparator=","
                                decimalScale={2}
                                value={item.porcentaje}
                              />
                              <Typography fontWeight={"bold"}>% </Typography>
                            </Grid>
                          </td>
                          {typeReport === "Vencimiento" ? <td style={{ fontSize: 14 }}>{item.sugerencia}</td> : null}
                        </>
                      ) : (
                        <></>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default TableInformation;
